module.exports = __webpack_public_path__ + "static/media/DSC_5578.458af986.jpg";